// @flow

import React, { Fragment } from 'react';
import { typeof push as PushType } from 'react-router-redux';

import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import { Grid, Row, Col, SPACING } from 'clark-styles';
import type { SessionType } from 'types/sessions';
import type { EngagementsType } from 'types/engagements';
import type { ClientsType } from 'types/clients';
import type { SubjectsType } from 'types/subjects';

import SessionsListEmpty from 'components/sessions/list/empty';
import { SmallHide, SmallOnly } from 'styles/table';

import SessionRow from './row';
import TableHeader from './table-header';

import { Wrapper, FullWidthBg, StyledSchedule } from './styles';

import { orderedFutureSessions, transformTutorSessionsToCalendarEvents } from '../helpers';

type PropsType = {
  clients: ClientsType,
  engagements: EngagementsType,
  futureSessions: SessionType[],
  pastSessions: SessionType[],
  engagementDataEmpty: boolean,
  subjects: SubjectsType,
  dispatchPush: PushType,
};

const ScheduledSessions = ({
  clients,
  engagements,
  futureSessions,
  pastSessions,
  subjects,
  dispatchPush,
  engagementDataEmpty,
}: PropsType) => (
  <Fragment>
    <SmallOnly>
      <Grid marginTop={SPACING.S_1}>
        <TableHeader />
        {futureSessions.length ? (
          <Fragment>
            {map(orderedFutureSessions(futureSessions), session => (
              <SessionRow
                clients={clients}
                key={session.id}
                session={session}
                subjects={subjects}
                tutoringEngagements={engagements}
              />
            ))}
          </Fragment>
        ) : (
          <Row>
            <SessionsListEmpty hide={engagementDataEmpty} />
          </Row>
        )}
      </Grid>
    </SmallOnly>
    <SmallHide>
      <Wrapper>
        <FullWidthBg />
        <Grid>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <StyledSchedule
                events={transformTutorSessionsToCalendarEvents(
                  futureSessions.concat(pastSessions),
                  clients,
                )}
                onSelectEvent={event => dispatchPush(`sessions/${event.id}`)}
                onSelectSlot={({ start, end }) =>
                  !isEmpty(engagements) &&
                  dispatchPush({
                    pathname: '/sessions/new',
                    state: { start, end },
                  })
                }
              />
            </Col>
          </Row>
        </Grid>
      </Wrapper>
    </SmallHide>
  </Fragment>
);

export default ScheduledSessions;



// WEBPACK FOOTER //
// ./src/components/sessions/list/scheduled/index.js